import queryString from "query-string";
import { useLocation, useParams } from "react-router";
import { WEEK_TO_DATE_CUSTOMER_CONFIG } from "../../../constants/customers";
import { ReportParams } from "reports/types";
export const useGetWeekToDateProps = () => {
  const location = useLocation();

  const { machineId } = queryString.parse(location.search) as {
    machineId: string;
  };

  const { ckey: tenant } = useParams() as ReportParams;

  const trueMachineId = machineId ? machineId : "default";

  return WEEK_TO_DATE_CUSTOMER_CONFIG[tenant][trueMachineId];
};
